// extracted by mini-css-extract-plugin
export var btn = "D_bh x_tw x_tf g_dh g_dw g_dl g_gd";
export var full = "D_vF g_ch g_cs";